/**
 * The one colour these charts are allowed to use, and why it is this one.
 *
 * The subsystems in a breakdown are NOMINAL - swapping structure and guidance
 * changes nothing - so they are one series in one hue, not eight. Colouring each
 * bar by its own value would spend the identity channel re-encoding the thing bar
 * length already shows, and giving each quantity its own hue would need a ninth
 * colour the moment a program marks a ninth attribute `@RollsUp`. The chart's
 * heading says which quantity it is; colour says nothing, on purpose.
 *
 * Both steps are the documented categorical slot 1 and were VALIDATED against
 * this app's own paper surfaces rather than the palette's defaults, because
 * contrast only means anything against the surface the chart really renders on:
 *
 *     validate_palette.js "#2a78d6" --mode light --surface "#ffffff"  -> all pass
 *     validate_palette.js "#3987e5" --mode dark  --surface "#1e1e1e"  -> all pass
 *
 * MUI's own primary was the obvious candidate and it FAILS in dark mode: `#90caf9`
 * sits at OKLCH L 0.816 against a 0.48-0.67 band and chroma 0.09 against a 0.10
 * floor - it is a text and accent colour, not a fill. So the marks take the
 * validated step and everything that is not a mark - gridlines, tick labels,
 * values - takes a theme token, which is what keeps the charts in the app's
 * visual language rather than beside it.
 */

/** The mark colour for the mode, from the documented palette's slot 1. */
export function seriesColor(mode: 'light' | 'dark'): string {
  return mode === 'dark' ? '#3987e5' : '#2a78d6'
}
